import Spacing from '@components/atoms/Spacing';
import { Heading1, Paragraph } from '@components/atoms/Typography';
import PageContainer from '@components/molecules/PageContainer';
import CompareStatsForm from '@components/organisms/forms/CompareStatsForm';
import BREAKPOINTS from '@lib/constants/breakpoints';
import motorcycleStats from '@lib/helpers/motorcycleStats';
import { GetStaticProps } from 'next';
import NextImage from 'next/image';
import React from 'react';
import styled from 'styled-components';

interface Props {
  stats: any[];
}

const Header = styled.header`
  position: relative;
  padding-top: 80px;

  @media screen and (max-width: ${BREAKPOINTS.medium}) {
    padding-top: 50px;

    button {
      width: 100%;
    }
  }
`;

const HeaderGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;

  > div {
    padding: 32px;

    form {
      margin: 0 auto;
    }
  }

  @media screen and (max-width: ${BREAKPOINTS.medium}) {
    grid-template-columns: 1fr;

    > div:nth-child(2) {
      display: none;
    }
  }
`;

const Stats = ({ stats }: Props) => (
  <PageContainer
    title="Comparativo - Escolher Modelos | Luna"
    metaDescription="Compare dois modelos de motos para ver a diferença entre elas"
  >
    <Header>
      <HeaderGrid>
        <div style={{ maxWidth: 800 }}>
          <Heading1 center>Comapare os dados de cada moto</Heading1>
          <Spacing top={2}>
            <Paragraph center>Escolha 2 modelos para comparar</Paragraph>
          </Spacing>

          <CompareStatsForm stats={stats} />
        </div>
        <div style={{ position: 'relative', height: 600 }}>
          <NextImage
            alt="Moto sozinha"
            src="https://images.unsplash.com/photo-1599718430237-54541d38d414?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=750&q=80"
            layout="fill"
            quality={100}
            objectFit="cover"
          />
        </div>
      </HeaderGrid>
    </Header>
  </PageContainer>
);

export const getStaticProps: GetStaticProps<Props> = async () => {
  const stats = await motorcycleStats.getAll();

  return {
    props: {
      stats,
    },
  };
};

export default Stats;
